<script setup lang="ts">
  import { ArrowRight, X } from "lucide-vue-next";
  import type { Announcement } from "@/types";

  defineProps<{
    announcement: Pick<Announcement, "title" | "body" | "url">;
    position?: number;
    total?: number;
  }>();

  const emit = defineEmits<{
    close: [];
    open: [];
  }>();
</script>

<template>
  <div class="relative flex flex-col gap-1.5 rounded-lg border border-border bg-white p-3.5 shadow-sm">
    <div class="flex items-center gap-2">
      <span class="text-2xs font-semibold uppercase tracking-[0.06em] text-episto-teal-700">What's new</span>
      <span
        v-if="total && total > 1"
        class="text-2xs text-muted-foreground">
        {{ position }}/{{ total }}
      </span>
      <button
        type="button"
        aria-label="Dismiss"
        class="ml-auto inline-flex size-6 items-center justify-center rounded-md text-muted-foreground transition-colors hover:text-episto-navy"
        @click="emit('close')">
        <X class="size-3.5" />
      </button>
    </div>
    <div class="break-words text-sm font-semibold leading-snug text-episto-navy">{{ announcement.title }}</div>
    <div
      v-if="announcement.body"
      class="break-words text-xs leading-relaxed text-muted-foreground">
      {{ announcement.body }}
    </div>
    <a
      :href="announcement.url"
      target="_blank"
      rel="noopener noreferrer"
      class="group mt-1 inline-flex items-center gap-1 self-start text-xs font-semibold text-episto-navy hover:underline"
      @click="emit('open')">
      Learn more
      <ArrowRight class="size-3.5 text-episto-teal-700 transition-transform group-hover:translate-x-0.5" />
    </a>
  </div>
</template>
